import Toast from 'react-native-toast-message';

interface Params {
  text1?: string;
  text2?: string;
}

export const showSuccessToast = (params: Params) =>
  Toast.show({
    type: 'success',
    ...params,
  });

export const showInfoToast = (params: Params) =>
  Toast.show({
    type: 'info',
    ...params,
  });

export const showErrorToast = (params: Params) =>
  Toast.show({
    type: 'error',
    ...params,
  });
